import React, { useState } from "react";

import { FormattedMessage } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { ReactComponent as IconAccordionExpand18 } from "../../icons/icon/18/a-icon-accordeon-expand-18.svg";
import { ReactComponent as IconAccordionMinimize18 } from "../../icons/icon/18/a-icon-accordeon-minimize-18.svg";
import LinkButton from "../button/linkButton";

import "./mediaGallerySection.scss";

const numberOfTiles = 6;
const numberOfMoreTiles = 4;

const MediaGallerySection = ({
  children,
  title = null,
}) => {
  const [numberOfShowTiles, setNumberOfShowTiles] = useState(
    children.length < numberOfTiles ? children.length : numberOfTiles,
  );

  return (
    <div className="media-gallery">
      <div className="media-gallery__content media-gallery-section">
        <Row>
          {title && <Col xs={12} className="media-gallery-section__title">{title}</Col>}
          {React.Children.map(children, (item, index) => (
            index < numberOfShowTiles && (
              <Col xl={6}>{item}</Col>
            )))}
          {children.length > numberOfTiles && (
            <Col xs={12}>
              {!(children.length <= numberOfTiles) && (numberOfShowTiles < children.length
                ? (
                  <LinkButton
                    onClick={() => {
                      const addMoreElements = numberOfShowTiles + numberOfMoreTiles;
                      const changeNumberOfShowElements = (addMoreElements + 1) > children.length
                        ? children.length
                        : addMoreElements;

                      setNumberOfShowTiles(changeNumberOfShowElements);
                    }}
                    variant="outline-light"
                  >
                    <FormattedMessage id="listsection.show_more" /> <IconAccordionExpand18 />
                  </LinkButton>
                )
                : (
                  <LinkButton
                    onClick={() => {
                      setNumberOfShowTiles(numberOfTiles);
                    }}
                    variant="outline-light"
                  >
                    <FormattedMessage id="listsection.show_less" /> <IconAccordionMinimize18 />
                  </LinkButton>
                ))}
            </Col>
          )}
        </Row>
      </div>
    </div>
  );
};

MediaGallerySection.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  title: PropTypes.string,
};

export default MediaGallerySection;
